export default "__VITE_ASSET__BuREwJTS__"